import * as React from 'react';
export const linkSvg = React.forwardRef(function linkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Z',
      fill: '#00D66F',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.644 4H5.588c.4 1.672 1.568 3.101 3.03 4-1.465.899-2.63 2.328-3.03 4h2.056c.51-1.547 1.92-2.89 3.653-3.165V7.163C9.561 6.89 8.151 5.547 7.644 4Z',
      fill: '#011E0F',
    }),
  );
});
linkSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var link = {
  category: 'card',
  colorable: false,
  name: 'link',
  svg: linkSvg,
};
